import axios from "axios";
import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "../utils/axios";

export const postSearchHistory = async (searchQuery, userId) => {
  const response = await axiosInstanceWithToken.post(
    `${HOST_API_KEY}/search-history/create-new-term`,
    {
      userId,
      searchTerm: searchQuery,
    }
  );
  return response;
};

export const fetchSearchHistoryByUserId = async (userId) => {
  const response = await axios.get(
    `${HOST_API_KEY}/search-history/get-search-terms/${userId}`
  );
  return response.data;
};

/**
 * 검색 전에 보여 줄 목록.
 *
 * ⭐ **사람이 정한 것이 먼저다.** 어드민 「검색 밀기」에 넣어 둔 것이 있으면 그것을
 *    쓰고, 없을 때만 자동 순위(최근 12시간 검색량)를 쓴다.
 *    시즌에 밀 것을 미리 짜 두려고 만든 자리다 — 벚꽃 시즌엔 「진해 벚꽃축제」.
 * ⚠️ 정한 목록을 받아 오다 실패해도 **조용히 자동 순위로 넘어간다.** 이 자리가
 *    비면 검색 전 화면이 통째로 허전해진다.
 */
export const getPopularSearchTerms = async ({ hours = 12, limit = 10 } = {}) => {
  try {
    const curated = await axios.get(`${HOST_API_KEY}/search-history/curated`, {
      timeout: 4000,
    });
    const items = curated?.data?.items;
    if (Array.isArray(items) && items.length > 0) return items;
  } catch (_) {
    // 정한 목록을 못 받아도 아래 자동 순위가 받아 준다.
  }

  const response = await axios.get(`${HOST_API_KEY}/search-history/popular`, {
    params: { hours, limit },
  });
  return response?.data;
};
